import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { SimsoAction } from 'src/actions/simso.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Select,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

const CreateEditDialog = (props) => {
    const dispatch = useDispatch()
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.simso)
    const [so_dien_thoai, setSoDienThoai] = useState("")
    const [nha_mang, setNhaMang] = useState("-99")
    const [number_type, setNumberType] = useState("-99")
    const [trang_thai, setTrangThai] = useState("con_sim")
    const [nguon_nhap, setNguonNhap] = useState("")
    const [ghi_chu, setGhiChu] = useState("")
    const [gia_goc, setGiaGoc] = useState("0")
    const [gia_khach_hang, setGiaKhachHang] = useState("0")
    const [gia_khach_hang_khuyen_mai, setGiaKhachHangKhuyenMai] = useState("0")
    const [gia_si_1, setGiaSi1] = useState("0")
    const [gia_si_2, setGiaSi2] = useState("0")
    const [gia_si_3, setGiaSi3] = useState("0")
    const [loai_sim, setLoaiSim] = useState({})

    const danhSachLoaiSim = SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR;

    useEffect(() => {
        if (items.length > 0) {
            return;
        }
    }, [])

    useEffect(() => {
        if (props.type === 'EDIT') {
            if (selected) {
                setSoDienThoai(selected.so_dien_thoai_co_dau_cham)
                setNhaMang(selected.nha_mang)
                setNumberType(selected.number_type)
                setTrangThai(selected.trang_thai)
                setNguonNhap(selected.nguon_nhap)
                setGhiChu(selected.ghi_chu)
                setGiaGoc(selected.gia_goc)
                setGiaKhachHang(selected.gia_khach_hang)
                setGiaKhachHangKhuyenMai(selected.gia_khach_hang_khuyen_mai)
                setGiaSi1(selected.gia_si_1)
                setGiaSi2(selected.gia_si_2)
                setGiaSi3(selected.gia_si_3)

                setLoaiSim({});

                if (selected.types && Object.keys(selected.types).length > 0) {
                    let inputLoaiSo = {};

                    Object.entries(selected.types).forEach(([key, value]) => {
                        inputLoaiSo[value.loai_sim] = 1;
                    });

                    setLoaiSim(inputLoaiSo);
                }
            }
        }
    }, [selected])

    const onPressPositive = () => {
        if (so_dien_thoai === "") {
            alert('Vui lòng nhập số điện thoại!');
            return;
        }
        if (nha_mang === "" || nha_mang == "-99") {
            alert('Vui lòng chọn nhà mạng!');
            return;
        }
        if (number_type === "" || number_type == "-99") {
            alert('Vui lòng chọn loại thuê bao!');
            return;
        }
        if (trang_thai === "" || trang_thai == "-99") {
            alert('Vui lòng chọn trạng thái!');
            return;
        }
        // if (nguon_nhap === "") {
        //     alert('Vui lòng cho biết nguồn nhập!');
        //     return;
        // }
        if (gia_goc === "") {
            alert("Vui lòng nhập giá gốc!");
            return;
        }
        if (gia_khach_hang === "") {
            alert("Vui lòng nhập giá khách hàng!");
            return;
        }
        if (gia_si_1 === "") {
            alert("Vui lòng nhập giá sỉ 1!");
            return;
        }
        if (gia_si_2 === "") {
            alert("Vui lòng nhập giá sỉ 2!");
            return;
        }
        if (gia_si_3 === "") {
            alert("Vui lòng nhập giá sỉ 3!");
            return;
        }

        let outputLoaiSo = [];

        if (Object.keys(loai_sim).length > 0) {
            Object.entries(loai_sim).forEach(([key, value]) => {
                if (value == 1) {
                    outputLoaiSo.push(key);
                }
            });
        }

        if (outputLoaiSo.length < 1) {
            alert('Vui lòng chọn ít nhất 1 loại số!');
            return;
        }

        if (props.type === 'EDIT') {
            dispatch(SimsoAction.update(selected.id, { 
                so_dien_thoai, 
                nha_mang, 
                number_type, 
                trang_thai,
                // nguon_nhap, 
                ghi_chu,
                gia_goc, 
                gia_khach_hang, 
                gia_khach_hang_khuyen_mai,
                gia_si_1, 
                gia_si_2, 
                gia_si_3, 
                loai_sim: outputLoaiSo,
            }))
        } else {
            dispatch(SimsoAction.create({ 
                so_dien_thoai, 
                nha_mang, 
                number_type, 
                trang_thai,
                // nguon_nhap, 
                ghi_chu,
                gia_goc, 
                gia_khach_hang,
                gia_khach_hang_khuyen_mai, 
                gia_si_1, 
                gia_si_2, 
                gia_si_3, 
                loai_sim: outputLoaiSo,
            }))
        }
        resetState();
        props.handleClose();
    }

    const resetState = () => {
        setSoDienThoai("")
        setNhaMang("-99")
        setNumberType("-99")
        setTrangThai("chua_co_chu_so_huu")
        setNguonNhap("")
        setGhiChu("")
        setGiaGoc("0")
        setGiaKhachHang("0")
        setGiaKhachHangKhuyenMai("0")
        setGiaSi1("0")
        setGiaSi2("0")
        setGiaSi3("0")
        setLoaiSim({})
    }

    const chonLoaiSim = (e, value) => {
        setLoaiSim({
            ...loai_sim,
            [value]: e.target.value == 1 ? 2 : 1
        })
    }

    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
            <DialogContent style={{ width: 600, paddingTop: 20 }}>
                <Grid
                    container
                    spacing={3}
                >
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Số điện thoại"
                            name="so_dien_thoai"
                            onChange={(e) => setSoDienThoai(e.target.value)}
                            required
                            value={so_dien_thoai}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <Select1
                            style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                            name="nha_mang"
                            value={nha_mang || -99}
                            onChange={(e) => setNhaMang(e.target.value)}
                            variant="outlined"
                            startAdornment={(
                                <InputAdornment position="start">
                                <SvgIcon fontSize="small" color="action">
                                    <SearchIcon />
                                </SvgIcon>
                                </InputAdornment>
                            )}
                            >
                            <MenuItem value="-99">Nhà mạng...</MenuItem>
                            <MenuItem value="MOBIFONE">MOBIFONE</MenuItem>
                            <MenuItem value="VINAPHONE">VINAPHONE</MenuItem>
                            <MenuItem value="VIETTEL">VIETTEL</MenuItem>
                        </Select1>
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <Select1
                            style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                            name="number_type"
                            value={number_type || -99}
                            onChange={(e) => setNumberType(e.target.value)}
                            variant="outlined"
                            startAdornment={(
                                <InputAdornment position="start">
                                <SvgIcon fontSize="small" color="action">
                                    <SearchIcon />
                                </SvgIcon>
                                </InputAdornment>
                            )}
                            >
                            <MenuItem value="-99">Loại thuê bao...</MenuItem>
                            <MenuItem value="1">TRẢ TRƯỚC</MenuItem>
                            <MenuItem value="2">TRẢ SAU</MenuItem>
                        </Select1>
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <Select1
                            style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                            name="trang_thai"
                            value={trang_thai || -99}
                            onChange={(e) => setTrangThai(e.target.value)}
                            variant="outlined"
                            startAdornment={(
                                <InputAdornment position="start">
                                <SvgIcon fontSize="small" color="action">
                                    <SearchIcon />
                                </SvgIcon>
                                </InputAdornment>
                            )}
                            >
                            <MenuItem value="-99">Trạng thái...</MenuItem>
                            <MenuItem value="con_sim">Còn sim</MenuItem>
                            <MenuItem value="giu_so">Giữ số</MenuItem>
                            <MenuItem value="da_ban">Đã bán</MenuItem>
                        </Select1>
                    </Grid>
                    {/* <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Nguồn nhập"
                            name="nguon_nhap"
                            onChange={(e) => setNguonNhap(e.target.value)}
                            required
                            value={nguon_nhap}
                            variant="outlined"
                        />
                    </Grid> */}
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Ghi chú"
                            name="ghi_chu"
                            onChange={(e) => setGhiChu(e.target.value)}
                            value={ghi_chu}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Giá gốc"
                            name="gia_goc"
                            onChange={(e) => setGiaGoc(e.target.value)}
                            value={gia_goc}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Giá sỉ 1"
                            name="gia_si_1"
                            onChange={(e) => setGiaSi1(e.target.value)}
                            value={gia_si_1}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Giá sỉ 2"
                            name="gia_si_2"
                            onChange={(e) => setGiaSi2(e.target.value)}
                            value={gia_si_2}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Giá sỉ 3"
                            name="gia_si_3"
                            onChange={(e) => setGiaSi3(e.target.value)}
                            value={gia_si_3}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Giá khách hàng"
                            name="gia_khach_hang"
                            onChange={(e) => setGiaKhachHang(e.target.value)}
                            value={gia_khach_hang}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Giá khách hàng khuyến mãi"
                            name="gia_khach_hang_khuyen_mai"
                            onChange={(e) => setGiaKhachHangKhuyenMai(e.target.value)}
                            value={gia_khach_hang_khuyen_mai}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <Typography
                            variant="body1"
                            color="gray"
                        >
                            <h3>Loại sim *</h3>
                        </Typography>
                    </Grid>
                    {Object.entries(danhSachLoaiSim).map(([key, value]) => (
                        <Grid item md={6} xs={6} key={key} style={{paddingTop: 0}}>
                            <Typography
                                className='checkbox-container'
                                variant="body1"
                            >
                                <div style={{width: '30px'}}>
                                    <Checkbox
                                        checked={loai_sim[key] == 1 ? true : false}
                                        onChange={(event) => chonLoaiSim(event, key)}
                                        value={loai_sim[key] == 1 ? 1 : 2}
                                        style={{ width: '20px' }}
                                    />
                                </div>
                                <div style={{padding: 0}}>
                                    {value}
                                </div>
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Huỷ</Button>
                <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
            </DialogActions>
        </Dialog >
    );
}

export default CreateEditDialog;